import React from 'react';
import { FaPlay, FaHeadset, FaEnvelope, FaPhone } from 'react-icons/fa';

export default function AboutUs() {
  return (
    <div className="max-w-6xl mx-auto px-4 py-12 bg-black text-gray-100">
      <h1 className="text-4xl md:text-5xl font-bold mb-8 text-transparent bg-clip-text bg-gradient-to-r from-[#FF1493] to-[#FF8C00]">
        About AweitFlix
      </h1>
      
      <div className="space-y-8 text-lg">
        <section>
          <h2 className="text-3xl font-bold mb-6 text-white">Welcome to AweitFlix - Where Stories Come Alive</h2>
          <p className="leading-relaxed">
            At AweitFlix, we're revolutionizing entertainment in Africa by bringing you unlimited access to premium movies, series, and documentaries. Our streaming platform delivers crystal-clear content tailored for African audiences and the world at large, available anytime, anywhere.
          </p>
        </section>

        <section>
          <h2 className="text-3xl font-bold mb-6 text-white">Our Premium Experience</h2>
          <p className="mb-6">
            We've built Africa's most immersive streaming platform with cutting-edge technology:
          </p>
          
          <div className="grid md:grid-cols-2 gap-6">
            <div className="bg-gray-900 p-6 rounded-xl border border-gray-800">
              <h3 className="font-bold text-xl flex items-center mb-3 text-[#FF1493]">
                <FaPlay className="mr-3" />
                Unlimited Streaming
              </h3>
              <p>
                Watch thousands of hours of content without ads interrupting your experience. Our adaptive streaming ensures perfect playback on any device.
              </p>
            </div>

            <div className="bg-gray-900 p-6 rounded-xl border border-gray-800">
              <h3 className="font-bold text-xl flex items-center mb-3 text-[#FF8C00]">
                <FaHeadset className="mr-3" />
                Personalized Recommendations
              </h3>
              <p>
                Our AI learns your tastes to suggest content you'll love. Discover hidden gems and new releases tailored just for you.
              </p>
            </div>
          </div>
        </section>

        <section>
          <h2 className="text-3xl font-bold mb-6 text-white">Our Vision</h2>
          <p className="text-xl leading-relaxed">
            To become World's most loved streaming platform by delivering authentic scripts and stories with global production quality.
          </p>
        </section>

        <section>
          <h2 className="text-3xl font-bold mb-6 text-white">Our Mission</h2>
          <ul className="list-disc pl-6 space-y-3 text-lg">
            <li>To showcase African talent and stories to the world</li>
            <li>To make premium entertainment accessible across all devices</li>
            <li>To support African filmmakers through fair compensation</li>
            <li>To innovate constantly in streaming technology</li>
          </ul>
        </section>

        <section>
          <h2 className="text-3xl font-bold mb-6 text-white">Why Choose AweitFlix?</h2>
          <ul className="space-y-4">
            <li className="flex items-start">
              <div className="bg-[#FF1493] p-1 rounded-full mr-4 mt-1">
                <FaPlay className="text-white text-sm" />
              </div>
              <span>
                <strong className="text-white">Largest African Library</strong> - Over 10,000 hours of exclusive African content
              </span>
            </li>
            <li className="flex items-start">
              <div className="bg-[#FF8C00] p-1 rounded-full mr-4 mt-1">
                <FaPlay className="text-white text-sm" />
              </div>
              <span>
                <strong className="text-white">4K Streaming</strong> - The highest quality streaming available in Africa
              </span>
            </li>
            <li className="flex items-start">
              <div className="bg-[#FF1493] p-1 rounded-full mr-4 mt-1">
                <FaPlay className="text-white text-sm" />
              </div>
              <span>
                <strong className="text-white">Multi-Device</strong> - Watch on 4 screens simultaneously
              </span>
            </li>
            <li className="flex items-start">
              <div className="bg-[#FF8C00] p-1 rounded-full mr-4 mt-1">
                <FaPlay className="text-white text-sm" />
              </div>
              <span>
                <strong className="text-white">Local Support</strong> - 24/7 customer care based in Kampala
              </span>
            </li>
          </ul>
        </section>

        <section className="bg-gradient-to-r from-[#FF1493] to-[#FF8C00] text-white p-8 rounded-xl">
          <div className="flex flex-col md:flex-row items-center">
            <div className="mb-6 md:mb-0 md:mr-8">
              <h2 className="text-3xl font-bold mb-3">"Feel the Reel!"</h2>
              <p className="text-xl opacity-90">Our promise of authentic cinematic experiences</p>
            </div>
            <div className="space-y-3">
              <div className="flex items-center">
                <FaEnvelope className="mr-3" />
                <span>support@aweitflix.com</span>
              </div>
              <div className="flex items-center">
                <FaPhone className="mr-3" />
                <span>+256 761832669</span>
              </div>
            </div>
          </div>
          <p className="mt-6 text-center text-lg font-medium">
            🎬 AweitFlix - Redefining African Entertainment!
          </p>
        </section>
      </div>
    </div>
  );
}